// extracted by mini-css-extract-plugin
export default {"dialog":"AddTalent-module__dialog--f855","content":"AddTalent-module__content--7e6f","menu":"AddTalent-module__menu--5659"};